import React from "react";
import Grid from "@material-ui/core/Grid";
import { CSSTransition} from 'react-transition-group';
import {withRouter } from "react-router-dom";
import Progress from "../ProgressBar";

import backgroundImage from "../../assets/images/main_background.png";
import star from "../../assets/images/img_star.png";
import picoLogo from "../../assets/images/logo_red.png";
import Exit from "../../assets/images/exit.png";
import starShow from "../../assets/images/img_star_show.png";
import roundLight from "../../assets/images/img_raund_light.png";
import giftBox from "../../assets/images/box_gift.png";
import {setAuth} from './../../Plugins/Axios'
import '../../App.scss';
import { bounce } from 'react-animations';
import Radium, {StyleRoot} from 'radium';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "../pageComponents/Common/Dialog";
import Cookies from 'js-cookie'

class SplashScreen extends React.Component {
    constructor(props) {
        super(props)
        this.state={
            trueState:true,
            appHasLoaded:false,
            style: {
                completed:5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize:'100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width:'100%',
                    backgroundColor:"#343168",
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0',
                },
                mainRow: {
                    margin: 'auto',
                    width: '95%',
                    padding: 'auto',
                    overflow:'hidden',
                    flex:1,
                    minHeight:'0',
                    height: '100%'
                },
                starSection:{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems:'center',
                    position:'relative',
                    animation: 'x 10s',
                    animationName: Radium.keyframes(bounce, 'bounce'),
                },
                star: {
                    textAlign: 'center',
                    width: '50%',
                    position:'absolute',
                },
                picoLogo: {
                    width: '30%',
                    marginLeft:'auto',
                    marginTop: '5%',
                    zIndex:'100',
                    position:'absolute'
                },
                progressSection:{
                    marginBottom:'5px',
                    padding: '30px',
                    display:'flex'
                },
            }
        }
    }

    componentDidMount() {
        this.props.toggleBottomNavbar()
    }
    handleProgressResult = (progressResult) =>{
        if (!progressResult.success){
            this.setState({
                showDialog:true,
            })
        }
        else {
            Cookies.set('appLoaded', progressResult.token, { expires: 1})

            this.props.history.push('/home')
        }
    }
    render() {
        const handleClose=(()=>{
            this.setState({
                showDialog:false
            })
        })
        const progressFail={
             button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
             cancelButton:{
                text:'خروج',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'#ffffff',
                borderColor:'transparent',
            },
             exitButton:{
                text:'تلاش مجدد',
                backgroundColor:'green',
                bottomFontSize:'15px',
                buttonTextColor:'#ffffff',
                borderColor:'transparent'
            },
            data:{
                 icon:Exit,
                 text:'خطا در برقراری اتصال ، اینترنت خود را بررسی کنید'
            }
        }
        const {trueState}=this.state
        return(
            <Grid direction={"column"} item container justify={"center"} style={this.state.style.root}>
                <Grid item sm={12} xs={12} direction={"column"} justify={'center'} container
                      style={{flex:'1',minHeight:'0'}}
                >
                    <Dialog
                        // disableBackdropClick
                        open={this.state.showDialog}
                        // open={true}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        style={{background:'transparent !important'}}
                        PaperProps={{
                            style: {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <DialogContent>
                            <CustomDialog data={progressFail}/>
                        </DialogContent>
                    </Dialog>
                    <Grid item container xs={12} justify={"center"} sm={12} className='scrollBar'
                          style={{flex:'1',minHeight:'0',overflow:'auto'}}>
                        <Grid justify={"center"} container spacing={3} style={this.state.style.mainRow}>
                            <CSSTransition
                                in={trueState}
                                appear={true}
                                timeout={2000}
                                classNames="splash-pico-logo"
                            >
                                <Grid
                                    container justify={"center"} item sm={12} xs={12} style={this.state.style.starSection}>
                                    <img src={star} style={this.state.style.star}/>
                                    <img src={picoLogo} style={this.state.style.picoLogo}/>
                                </Grid>
                            </CSSTransition>

                            <Grid alignItems={"flex-end"} cotainer sm={12} xs={12} style={this.state.style.progressSection}>
                                <Grid alignItems={"flex-end"} cotainer style={{width:'100%'}}>
                                    <Progress result={this.handleProgressResult}/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default withRouter (SplashScreen)